export default __webpack_public_path__ + "static/media/emptyNotification.05ef2d3a.svg";